var ohm = require('..');

module.exports = ohm.makeRecipe(["grammar", {
  "source": "OperationsAndAttributes {\n\n  AttributeSignature =\n    name\n\n  OperationSignature =\n    name Formals?\n\n  Formals\n    = \"(\" ListOf<name, \",\"> \")\"\n\n  name  (a name)\n    = nameFirst nameRest*\n\n  nameFirst\n    = \"_\"\n    | letter\n\n  nameRest\n    = \"_\"\n    | alnum\n\n}"
}, "OperationsAndAttributes", null, "AttributeSignature", {
  "AttributeSignature": ["define", {
    "sourceInterval": [29, 58]
  }, null, [], ["app", {
    "sourceInterval": [54, 58]
  }, "name", []]],
  "OperationSignature": ["define", {
    "sourceInterval": [62, 100]
  }, null, [], ["seq", {
    "sourceInterval": [87, 100]
  }, ["app", {
    "sourceInterval": [87, 91]
  }, "name", []], ["opt", {
    "sourceInterval": [92, 100]
  }, ["app", {
    "sourceInterval": [92, 99]
  }, "Formals", []]]]],
  "Formals": ["define", {
    "sourceInterval": [104, 143]
  }, null, [], ["seq", {
    "sourceInterval": [118, 143]
  }, ["terminal", {
    "sourceInterval": [118, 121]
  }, "("], ["app", {
    "sourceInterval": [122, 139]
  }, "ListOf", [["app", {
    "sourceInterval": [129, 133]
  }, "name", []], ["terminal", {
    "sourceInterval": [135, 138]
  }, ","]]], ["terminal", {
    "sourceInterval": [140, 143]
  }, ")"]]],
  "name": ["define", {
    "sourceInterval": [147, 187]
  }, "a name", [], ["seq", {
    "sourceInterval": [168, 187]
  }, ["app", {
    "sourceInterval": [168, 177]
  }, "nameFirst", []], ["star", {
    "sourceInterval": [178, 187]
  }, ["app", {
    "sourceInterval": [178, 186]
  }, "nameRest", []]]]],
  "nameFirst": ["define", {
    "sourceInterval": [191, 223]
  }, null, [], ["alt", {
    "sourceInterval": [207, 223]
  }, ["terminal", {
    "sourceInterval": [207, 210]
  }, "_"], ["app", {
    "sourceInterval": [217, 223]
  }, "letter", []]]],
  "nameRest": ["define", {
    "sourceInterval": [227, 257]
  }, null, [], ["alt", {
    "sourceInterval": [242, 257]
  }, ["terminal", {
    "sourceInterval": [242, 245]
  }, "_"], ["app", {
    "sourceInterval": [252, 257]
  }, "alnum", []]]]
}]);